(async () => {
    const baseComponent = await import(window.theme.modules.baseComponent);
  
    customElements.define('product-variant-selector', class extends baseComponent.default {

        render() {
            this.addEventListener('change', this._variantChangeHandler.bind(this));
        }

        _variantChangeHandler(e) {
            this.forwardEvent('variantChange', {
                optionValueId: e.target.dataset.optionValueId, 
                optionIndex: e.target.dataset.optionIndex,
                variantId: e.target.dataset.variantId,
                imagePosition: e.target.dataset.imagePosition
            })
        }  
    });
  })();